import { Validators } from '@angular/forms';
import { prop, required, minLength, compose, propObject } from '@rxweb/reactive-form-validators';
import { PartType } from '../../../../../models/enums/part-type-enum';
import { CustomValidators } from '../../../../../extensions/custom-validators';
import { PersonType } from '../../../../../models/enums/person-type.enum';

export class BaseCompany {
    constructor(persona?: PersonType) {}

    @required()
    @minLength({ value: 14 })
    socialNumber: string;

    @required()
    businessName: string;

    @required()
    incorporationCountry: string;

    @compose({ validators: [ CustomValidators.isValidEmail()] })
    email?: string;

    @prop()
    phone: string;

    @prop()
    partType: number = PartType.None;

    @required()
    agentRegisterOriginType: string;

    @required()
    fullRegister = true;

    allowedFiles: string[] = [];
}
